import React, { Component } from "react";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import {
  Col,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "./post-tile.css";
export default class PostTileComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileDropdownOpen: false,
    };
  }

  toggle = () => {
    this.setState({ mobileDropdownOpen: !this.state.mobileDropdownOpen });
  };
  render() {
    const {
      avatarPic,
      avatarTitle,
      avatarSubtext,
      postTitle,
      postSubtext,
      postImage,
      postButton,
      userProfilePic,
      userProfileCenterName,
      dropdownItem,
    } = this.props;
    return (
      <div className="post-tile-container">
        {dropdownItem && (
          <Dropdown
            className="float-right"
            isOpen={this.state.mobileDropdownOpen}
            toggle={this.toggle}
            direction={"right"}
          >
            <DropdownToggle tag="span">
              {" "}
              <BiDotsHorizontalRounded size={"26px"} color="gray" />{" "}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem>{dropdownItem}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        )}
        {avatarPic && avatarTitle ? (
          <Row>
            <Col xs={2}>{avatarPic}</Col>
            <Col xs={10}>
              <span className="storyUsername">{avatarTitle}</span>
              <br />
              <span className="storyDate">{avatarSubtext}</span>
            </Col>
          </Row>
        ) : (
          ""
        )}

        <div
          onClick={
            (this.props.onClickMainContent && this.props.onClickMainContent) ||
            null
          }
          className="cursor-pointer post-title-subtitle-div my-2"
        >
          <h5 className="post-main-title">{postTitle}</h5>
          <p className="mt-1 post-sub-text">{postSubtext}</p>
        </div>

        {postImage && (
          <div
            className=" cursor-pointer image-div my-2"
            onClick={
              (this.props.onClickMainContent &&
                this.props.onClickMainContent) ||
              null
            }
          >
            <img className="img-fluid" src={postImage}></img>
          </div>
        )}
        {userProfilePic && userProfileCenterName ? (
          <div>
            <div
              className="image-center-div py-3 my-2"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {userProfilePic}
            </div>

            <div className="my-2 text-center">{userProfileCenterName}</div>
          </div>
        ) : (
          ""
        )}

        {postButton && <div className="buttondiv-div my-2">{postButton}</div>}
      </div>
    );
  }
}
